module.exports = __webpack_public_path__ + "static/media/preview-eye.29094421.svg";